<template>
    <div class="tab_action  tab_bg content-box" style="height:calc(100vh - 124px)">
        <div class="clothes-head" :style="{'border-bottom':typePartList.length>0?'':'none'}">
            <div class="head-box" :class="tabActive==typeObj.type?'active':''" v-for="(typeObj,index) in typePartList" :key="index" @click="tabActive=typeObj.type">{{typeObj.name}}</div>
        </div>
        <ul class="tab_ul">
            <center v-if="partsList.length<=0&&!loading"><img src="@/assets/images/null.png"/></center>      
            <div v-for="(part,index) in partsList" :key="index">
                <li v-if="part.type==tabActive" :class="{'tab_active':part.isAdd}" :style="{'background-image':'url('+part.partsPhoto+')'}"  @click="cutClothes(part)">
                    <div class="tab_div">{{part.partsName}}</div>
                </li> 
            </div>         
        </ul>
        <div class="savebtn"  >
        
            <span v-if="saveLoading" class="confirmbtn">保存中...</span>
            <span v-if="!saveLoading" class="confirmbtn" @click="toSave()">保存装扮</span>
        </div>
        <!-- <div class="clothes-bottom">
            <div class="save-btn" v-if="saveLoading">保存中...</div>
            <div class="save-btn" v-if="!saveLoading" @click="toSave()">保存装扮</div>
        </div> -->
      </div>
</template>
<script>
// import {PixiCommon} from '@/components/other/PixiCommon.js'
import {uploadFile} from '@/components/util/alioss.js'
import {UserCommon} from '@/components/other/UserCommon.js'
export default {
    name: 'Background',
    props:['modelClass','user'],
    data(){
        return {
            loading:false,
            partsList:[],
            tabActive:1,
            typeList:[],
            typePartList:[],//用来显示的
            saveLoading:false,
        }
    },
    mounted(){
     
        
    },
    created(){
        this.get('/vup/static/config/parts.json').then((res) => {
            this.typeList =res.data;
            // console.log(this.typeList);
            this.getPartList();//this.typeList[0]
            
        
        });
        // this.getPartList();
    },
    methods:{

        
        //获取配饰列表
        getPartList(){
            var that=this;
            this.loading=true;

            var clothesStr=this.user.clothesList;
            if(clothesStr==undefined||clothesStr==null){
                clothesStr="";
            }
            this.post("/parts/findPartsList",{modelId:this.user.modelId,type:0,pageIndex:0,pageSize:1000}).then((res)=>{
                that.loading=false;
                if (res.status == "200") {
                    var list=res.data[0];
                    var typeStr="";
                    for(var a=0;a<list.length;a++){
                        list[a].loading=false;
                        list[a].isAdd=false;
                        list[a].progress=0;
                        
                        if(clothesStr.indexOf(list[a].partsId)!=-1){
                            list[a].isAdd=true;
                        }
                        if(typeStr.indexOf(list[a].type+"-")==-1){
                            that.typePartList.push(that.typeList[list[a].type-1]);
                        }
                        typeStr+=list[a].type+"-";
                    }
                
                    that.partsList=list;
                    // console.log(that.typePartList)
                }else{
                    that.$message.error("获取失败！")
                }
            })
            .catch(()=>{
                that.loading=false;
                that.$message.error("获取异常！")
            })
        },

        //换装
        cutClothes(clothes){
            var that=this;
            
            for(var a=0;a<that.partsList.length;a++){
                if(that.partsList[a].type==clothes.type){
                    that.partsList[a].isAdd=false;
                }
            }
            clothes.isAdd=true;
            var list=[];
            list.push(JSON.parse(clothes.partsJson));
            this.modelClass.dbClothe(list,function(progress){
                clothes.progress=parseInt(progress*100);;
            },function(){
                clothes.loading=false;
                console.log("换装成功！")
            });
        },

        //保存
        toSave(){
            var that=this;
            console.log(PixiCommon.app.stage.getChildByName('zhujue'))
            // return;
            try{
                PixiCommon.app.renderer.extract.canvas(PixiCommon.app.stage.getChildByName('zhujue')).toBlob((b) => {
                    that.uploadCover(b)
                }, 'image/png');
            }catch(e){
                console.log("截图失败！"+err)
                that.saveClothes("");
            }
            
        },

        //上传封面
        uploadCover(blob){
            
            this.saveLoading=true;

            var that=this;
            var path=JSON.parse(this.user.modelJson).fileDir;
            var pathpart=path.split("/")

            //得到随机字符串的目录  model_xxxxxx
            pathpart.splice(pathpart.length-2,2);
            var newurl=pathpart.join("/");

            var name=newurl+"/model_cover_"+new Date().getTime()+".png";
            uploadFile(name,blob,function(progress){
                // 上传进度

            },function(results){
                var url=results.res.requestUrls[0].split("?uploadId=")[0];
                that.saveClothes(url);
            },function(err){
                console.log("封面上传失败！"+err)
                that.saveClothes("");
            })
        },
        //保存装扮
        saveClothes(cover){

            var idlist=[];
            for(var a=0;a<this.partsList.length;a++){
                if(this.partsList[a].isAdd){
                    idlist.push(this.partsList[a].partsId)
                }
            }

            
            var that=this;

            this.post("/roles/modifyRoles",{rolesId:this.user.rolesId,clothesList:JSON.stringify(idlist),rolesPhoto:cover}).then((res)=>{
                if (res.status == "200") {
                     that.$message.success("保存成功")
                     var user=this.user;
                     user.clothesList=JSON.stringify(idlist);
                     UserCommon.updateUser(user)
                }else{
                     that.$message.error("保存失败")
                }
                that.saveLoading=false;
            })
            .catch((fail)=>{
                that.saveLoading=false;
                that.$message.error("保存异常")
            })
        }

    }
}
</script>
<style lang="scss" scoped>
    .clothes-head{
        display: flex;
        border-bottom: 1px solid #eee;
        text-align: center;
        margin-bottom: 15px;
        .head-box{
            padding: 10px;
            cursor: pointer;
        }
        .head-box.active{
            border-bottom: 2px solid #eb9fa9;
        }
    }
    li{
        border: 3px solid #F6F6FB;
        box-sizing: border-box;
    }
    .tab_active {
        border: 3px solid #f4acb7;
        box-sizing: border-box;
    }

    .clothes-bottom{
        position: absolute;
        bottom: 0;
        background-color: #fff;
        border-top: 1px solid #eee;
        width: 100%;
        padding: 10px;
        text-align: center;
        .save-btn{
            display: inline-block;
            text-align: center;
            border-radius: 25px;
            padding: 10px 15px;
            background: #eb9fa9;
            cursor: pointer;
            color: #fff;
            &:hover {
                background-color: #e78d99;
            }
        }
    }
</style>
